import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=aab6ced6&scoped=true"
var script = {}
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=aab6ced6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab6ced6",
  null
  
)

export default component.exports